import { Box, BoxProps, Button, useTheme } from "@mui/material";
import Iconify from "./Iconify";

export interface Props extends BoxProps {
  onSwipeLeft: VoidFunction;
  onSwipeRight: VoidFunction;
}

export default function CarouselButtons({
  onSwipeLeft,
  onSwipeRight,
  ...other
}: Props) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        "& .MuiButton-root": {
          color: theme.palette.grey[300],
          backgroundColor: theme.palette.common.white,
          height: 40,
          width: 44,
          border: `1px solid ${theme.palette.grey[300]}`,
        },
      }}
      {...other}
    >
      <Button
        onClick={onSwipeLeft}
        sx={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
      >
        <Iconify icon={"mingcute:left-line"} width={20} height={20} />
      </Button>
      <Button
        onClick={onSwipeRight}
        sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
      >
        <Iconify icon={"mingcute:right-line"} width={20} height={20} />
      </Button>
    </Box>
  );
}
